import React, { useContext, useEffect, useState } from "react";
import { Grid, Modal, TextField, InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Styles from "./index.module.scss";
import urlLinks from "../../UrlLinks";
import Axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import CloseSharpIcon from "@material-ui/icons/CloseSharp";
import { ScaleLoader } from "react-spinners";
import { AppData } from "../../context/context";
import { CloseRounded } from "@material-ui/icons";

const flexDisplay = {
  marginBottom: "24px",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: "22px",
    width: "25%",
    height: "50%",
    borderRadius: "8px",
  },
  input: {
    "& .MuiInputBase-input": {
      borderLeft: "1px solid #E3E3E3",
      padding: "3% 4%",
    },
  },
}));

const LocationModal = ({
  uniqueKey,
  caption,
  openAdminNotes,
  setOpenAdminNotes,
  recruiterMasterId,
  inForm = false,
  modelList,
  removeSelectedElement,
}) => {
  const classes = useStyles();
  const { jobConfigMode } = useContext(AppData);

  /* Other states */

  const [searchBy, setSearchBy] = useState("");
  const [locationData, setLocationData] = useState([]);
  const [rows, setRows] = useState(locationData);
  const [isLoading, setIsLoading] = useState(false);

  const Loader = () => (
    <div style={{ margin: "40px auto", width: "fit-content" }}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  const handleSearchClose = () => {
    setSearchBy("");
    setRows(locationData);
  };

  const handleSearch = (e) => {
    setSearchBy(e.target.value);
    const filteredRows = locationData.filter((row) => {
      if (typeof row.name === "number") {
        let searchStr = row.name.toString();
        return searchStr.includes(e.target.value);
      } else {
        return row.name.toLowerCase().includes(e.target.value.toLowerCase());
      }
    });
    setRows(filteredRows);
  };

  /* UseEffects */

  useEffect(() => {
    setRows(locationData);
  }, [locationData]);

  useEffect(() => {
    setIsLoading(true);
    if (inForm) {
      setLocationData([...modelList]);
    } else if (uniqueKey !== "viewLanguage") {
      Axios.get(
        `${urlLinks.baseUrl}${urlLinks.jobs.jobslocation}?jobId=${recruiterMasterId}`
      )
        .then((response) => {
          setLocationData(response.data.response);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err", err);
        });
    }
    setIsLoading(false);
  }, [modelList]);

  return (
    <Modal
      className={classes.modal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openAdminNotes}
      onClose={() => setOpenAdminNotes(false)}
      closeAfterTransition
    >
      {isLoading ? (
        <Loader />
      ) : (
        <div className={classes.paper}>
          <Grid
            container
            style={{
              height: "-webkit-fill-available",
            }}
          >
            <Grid item xs={12} style={flexDisplay}>
              <span className={Styles.summaryText}>{caption}</span>
              <IconButton
                style={{ padding: "0" }}
                aria-label="close"
                onClick={() => setOpenAdminNotes(false)}
              >
                <CloseRounded
                  style={{
                    color: "#2E2E2E",
                  }}
                />
              </IconButton>
            </Grid>
            <Grid item xs={12} style={{ display: "flex" }}>
              <TextField
                className={`${classes.root}`}
                placeholder="Search"
                fullWidth
                value={searchBy}
                onChange={(event) => handleSearch(event)}
                variant="outlined"
                InputProps={{
                  className: classes.input,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "#757575" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <div className={Styles.searchButtonDiv1}>
                <IconButton
                  className={`${Styles.closeButton} ${
                    searchBy ? "" : Styles.noVisibility
                  }`}
                  onClick={handleSearchClose}
                >
                  <CloseSharpIcon />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12} className={Styles.locationGrid}>
              {rows?.map((loc, id) => (
                <div
                  key={id}
                  className="flexDisplay justifyContentSpaceBetween"
                  style={{
                    fontSize: uniqueKey !== "mainLocation" ? "14px" : "18px ",
                  }}
                >
                  <span>{loc.name}</span>
                  {jobConfigMode !== "view" &&
                    uniqueKey === "viewEditLocation" && (
                      <button
                        onClick={(el) => {
                          el.preventDefault();
                          removeSelectedElement(
                            "manualUpload",
                            "locations",
                            loc
                          );
                        }}
                        style={{
                          border: "none",
                          padding: "0",
                          background: "none",
                          cursor: "pointer",
                        }}
                      >
                        <CloseRounded
                          style={{
                            width: "20px",
                            height: "16px",
                          }}
                        />
                      </button>
                    )}
                </div>
              ))}
            </Grid>
          </Grid>
        </div>
      )}
    </Modal>
  );
};

export default LocationModal;
